import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment-timezone';
import { EVENT_STATES, EVENT_TYPES } from '../../utils/utils';
import IconCalendar from '@/components/general/icons/IconCalendar.vue';
import IconLocation from '@/components/general/icons/IconLocation.vue';
import IconUserTag from '@/components/general/icons/IconUserTag.vue';
import { GoogleMaps } from '~/utils/venue/location';
import { convertDateToDisplay } from '~/utils/date-time';
export default /*#__PURE__*/_defineComponent({
  __name: 'EventInfoPreview',
  props: {
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    event: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    organizer: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    venue: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    externalEvent: {
      type: Boolean,
      default: false
    },
    selectedOccurrence: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    selectedTimeslot: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    showOrganizerEmail: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'tabClicked'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t,
      d = _useI18n.d;
    var _useBreakpoint = useBreakpoint(),
      isSmallDevice = _useBreakpoint.mdAndDown;
    var config = reactive({
      eventDescription: true
    });
    var eventInPresale = computed(function () {
      return props.event.presaleEndAt && moment(props.event.presaleEndAt).isAfter(moment());
    });
    var isRecurringEvent = computed(function () {
      return props.event.type === EVENT_TYPES.RECURRING;
    });
    var showLocation = computed(function () {
      return props.event.type !== EVENT_TYPES.RECURRING || props.selectedOccurrence != null;
    });
    var eventName = computed(function () {
      if (props.event.status === EVENT_STATES.CANCELED) {
        return "".concat(props.event.name, " [").concat(t('myEvents.statusFilter.canceled').toUpperCase(), "] ");
      }
      if (eventInPresale.value) {
        return "[".concat(t('home.events.presale').toUpperCase(), "] ").concat(props.event.name);
      }
      return props.event.name;
    });
    var addressInfo = computed(function () {
      var _props$venue;
      return GoogleMaps.venueData((_props$venue = props.venue) === null || _props$venue === void 0 ? void 0 : _props$venue.address);
    });
    var encodedVenueUrl = computed(function () {
      return GoogleMaps.getLinkToVenue(props.venue);
    });
    var tab = computed({
      get: function get() {
        return props.value;
      },
      set: function set(value) {
        return emit('input', value);
      }
    });
    var tabHeight = computed(function () {
      return !isSmallDevice.value ? '1.5rem' : null;
    });
    var eventStart = computed(function () {
      var eventStartDate;
      if (props.selectedTimeslot) {
        eventStartDate = props.selectedTimeslot.startAt;
      } else if (props.selectedOccurrence) {
        eventStartDate = props.selectedOccurrence.startAt;
      } else {
        eventStartDate = props.event.startAt;
      }
      return convertDateToDisplay(eventStartDate, props.event.timezoneName);
    });
    var eventEnd = computed(function () {
      var eventEndDate;
      if (props.selectedTimeslot) {
        eventEndDate = props.selectedTimeslot.endAt;
      } else if (props.selectedOccurrence) {
        eventEndDate = props.selectedOccurrence.endAt;
      } else {
        eventEndDate = props.event.endAt;
      }
      return convertDateToDisplay(eventEndDate, props.event.timezoneName);
    });
    var eventGateTime = computed(function () {
      return convertDateToDisplay(props.event.gateTime, props.event.timezoneName);
    });
    var startDate = computed(function () {
      return d(eventStart.value, 'ddd_DD_MMMM_YYYY');
    });
    var startTime = computed(function () {
      return d(eventStart.value, 'HH_mm');
    });
    var endDate = computed(function () {
      return d(eventEnd.value, 'ddd_DD_MMMM_YYYY');
    });
    var endTime = computed(function () {
      return d(eventEnd.value, 'HH_mm');
    });
    var gateTime = computed(function () {
      return d(eventGateTime.value, 'HH_mm');
    });
    var onSameDay = computed(function () {
      return startDate.value === endDate.value;
    });
    var showEmail = computed(function () {
      var hasEmail = props.event.contactEmail || props.organizer.email;
      return props.showOrganizerEmail && hasEmail;
    });
    onMounted(function () {
      var urlParams = new URLSearchParams(window.location.search);
      var description = urlParams.get('description');
      if (description && description === 'false') {
        config.eventDescription = false;
      }
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      t: t,
      d: d,
      isSmallDevice: isSmallDevice,
      config: config,
      eventInPresale: eventInPresale,
      isRecurringEvent: isRecurringEvent,
      showLocation: showLocation,
      eventName: eventName,
      addressInfo: addressInfo,
      encodedVenueUrl: encodedVenueUrl,
      tab: tab,
      tabHeight: tabHeight,
      eventStart: eventStart,
      eventEnd: eventEnd,
      eventGateTime: eventGateTime,
      startDate: startDate,
      startTime: startTime,
      endDate: endDate,
      endTime: endTime,
      gateTime: gateTime,
      onSameDay: onSameDay,
      showEmail: showEmail,
      IconCalendar: IconCalendar,
      IconLocation: IconLocation,
      IconUserTag: IconUserTag
    };
  }
});